/* eslint-disable max-lines-per-function */
import { cn } from "tailwind-variants";
import StickersToolsTabs from "./StickersToolsTabs.vue";
// import StickersToolsShape from "./StickersToolsShape";
import StickersToolsBackground from "./StickersToolsBackground.vue";
import StickersToolsBorder from "./StickersToolsBorder.vue";
import "./StickersTools.scss";

export default function StickersTools({ artwork, ...restProps }) {
  return (
    <div {...restProps} className={cn("stickers-tools", restProps.className)}>
      <StickersToolsTabs
        artwork={artwork}
        slots={{
          default: ({ tab }) => (
            <>
              {tab === "background" ? (
                <StickersToolsBackground
                  artwork={artwork}
                  data-testid="stickers-tools-background"
                />
              ) : tab === "border" ? (
                <StickersToolsBorder artwork={artwork} data-testid="stickers-tools-border" />
              ) : null}
            </>
          )
        }}
        data-testid="stickers-tools-tabs"
      />
    </div>
  );
}
